import { SVGProps } from "react";

export default function AddDomainIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#6B6B6B", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33594 5.66634C1.33594 3.33301 2.66927 2.33301 4.66927 2.33301H11.3359C13.3359 2.33301 14.6693 3.33301 14.6693 5.66634V10.333C14.6693 12.6663 13.3359 13.6663 11.3359 13.6663H4.66927"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3307 6L9.24406 7.66667C8.55739 8.21333 7.43073 8.21333 6.74406 7.66667L4.66406 6"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33594 11H5.33594"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33594 8.33301H3.33594"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
